import * as React from "react";

import type { DesignaliProps } from "../../types";

export const NewReleases = React.forwardRef<SVGSVGElement, DesignaliProps>(
  ({  ...props }, forwardedRef) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        {...props}
        ref={forwardedRef}
      >
        <path  d="M11.51,2.09c.31-.12.66-.12.97,0,1.01.4,1.2,1.94,2.39,2.03.84.06,1.66-.64,2.5-.43.34.08.63.3.81.6.56.92-.16,2.28.75,3.04.64.53,1.69.46,2.24,1.11.23.27.35.63.32.99-.09,1.07-1.46,1.74-1.16,2.9.21.8,1.09,1.36,1.16,2.21.03.36-.08.72-.32.99-.69.82-2.2.55-2.63,1.66-.3.78.09,1.76-.36,2.5-.18.3-.48.52-.81.6-1.04.26-2.1-.86-3.1-.23-.72.45-.97,1.51-1.78,1.83-.31.12-.66.12-.97,0-.81-.32-1.07-1.38-1.78-1.83-.99-.62-2.08.48-3.1.23-.34-.08-.63-.3-.81-.6-.56-.92.16-2.28-.75-3.04-.64-.53-1.69-.46-2.24-1.11-.23-.27-.35-.63-.32-.99.07-.85.95-1.41,1.16-2.21.3-1.14-1.07-1.84-1.16-2.9-.03-.36.08-.72.32-.99.69-.82,2.2-.55,2.63-1.66.3-.78-.09-1.76.36-2.5.18-.3.48-.52.81-.6.84-.21,1.66.49,2.5.43,1.19-.09,1.38-1.63,2.39-2.03Z"/>
  <path  d="M9,13.33s.88,0,1.75,1.67c0,0,2.78-4.17,5.25-5"/>
</svg>
    );
  },
);

export default NewReleases;
